import api from './api';
import { API_ENDPOINTS } from '../constants';

export interface Break {
  id: string;
  user_id: string;
  attendance_id: string;
  store_id: string;
  date: string;
  start_time: string;
  end_time?: string;
  start_latitude?: number;
  start_longitude?: number;
  end_latitude?: number;
  end_longitude?: number;
  duration_minutes?: number;
  extra_minutes: number;
  status: 'active' | 'completed' | 'expired';
  notes?: string;
  user?: {
    id: string;
    first_name: string;
    last_name: string;
    employee_id: string;
  };
  attendance?: {
    id: string;
    date: string;
    clock_in_time?: string;
    clock_out_time?: string;
  };
}

export interface BreakFilters {
  attendanceId?: string;
  userId?: string;
  storeId?: string;
  clusterId?: string;
  startDate?: string;
  endDate?: string;
  date?: string;
  status?: 'active' | 'completed' | 'expired';
  page?: number;
  limit?: number;
}

const breakService = {
  /**
   * Get breaks with filters
   */
  getBreaks: async (filters: BreakFilters = {}): Promise<{
    breaks: Break[];
    pagination: {
      page: number;
      limit: number;
      total: number;
      pages: number;
    };
  }> => {
    const response = await api.get<{
      success: boolean;
      message: string;
      data: {
        breaks: Break[];
        pagination: {
          page: number;
          limit: number;
          total: number;
          pages: number;
        };
      };
    }>(API_ENDPOINTS.BREAKS.LIST, {
      params: filters,
    });
    return response.data.data;
  },

  /**
   * Get breaks for a specific attendance record
   */
  getBreaksByAttendance: async (attendanceId: string): Promise<Break[]> => {
    const response = await api.get<{
      success: boolean;
      message: string;
      data: Break[];
    }>(API_ENDPOINTS.BREAKS.GET_BY_ATTENDANCE(attendanceId));
    return response.data.data;
  },

  /**
   * Get active break for current user
   */
  getActiveBreak: async (): Promise<Break | null> => {
    const response = await api.get<{
      success: boolean;
      message: string;
      data: Break | null;
    }>(API_ENDPOINTS.BREAKS.GET_ACTIVE);
    return response.data.data;
  },
};

export default breakService;

